import React from "react";
import { Link } from "react-router-dom";
import abimg from "../../images/ab.png";

const AboutS2 = (props) => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className="wpo-about-section-s2 section-padding">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-6 col-md-12 col-12">
						<div className="wpo-about-wrap">
							<div className="wpo-about-img">
								<img src={abimg} alt="" />
								{/* <div className="wpo-total-raised">
									<div className="wpo-total-raised-wrap">
										<div className="wpo-total-raised-icon">
											<i className="fi flaticon-wallet-filled-money-tool"></i>
										</div>
										<div className="wpo-total-raised-text">
											<ul>
												<li>
													Total Raised<span>$25000</span>
												</li>
											</ul>
											<div className="progress-section">
												<div className="process">
													<div className="progress">
														<div className="progress-bar">
															<div className="progress-value"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> */}
								<div className="round-ball-1"></div>
								<div className="round-ball-2"></div>
								<div className="round-ball-3"></div>
								<div className="round-ball-4"></div>
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 col-12">
						<div className="wpo-about-text">
							<span>College Guidance</span>
							<h2>Shaping Futures with Purpose and Integrity</h2>
							<p>
								At Hill Academy, our College Guidance program is designed to
								empower students as they embark on their academic and career
								paths. Through personalized counseling and mentorship, we
								support each student's journey with a focus on both excellence
								and ethical values.
							</p>
							<ul>
								<li>
									Providing personalized guidance tailored to individual goals.
								</li>
								<li>
									Resources for navigating college applications and admissions.
								</li>
								<li>
									Support for building essential skills and leadership
									qualities.
								</li>
							</ul>
							<Link
								onClick={ClickHandler}
								className="theme-btn-s2"
								to="/college-guidance"
							>
								Learn More
							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default AboutS2;
